import React from 'react';
import { SelectionTree } from './tree/selection-tree';
import { SelectionTreeProvider, SelectionTreeContext } from './context';
import { HybridClientDataSource } from './data-source/hybrid-client-data-source';
import { ClientDataSource } from './data-source/client-data-source';
import { ServerDataSource } from './data-source/server-data-source';
import { IContextualSelectionTreeProps } from './types';

export const ContextualClientSelectionTree: React.FC<IContextualSelectionTreeProps> = ({
  treeItems,
  checkedItems,
  defaultCheckedItems,
  customFilter,
  onChange,
  i18n,
  ...restProps
}) => (
  <SelectionTreeProvider>
    <ClientDataSource
      treeItems={treeItems}
      customFilter={customFilter}
    />
    <SelectionTreeContext.Consumer>
      {({
        items,
        openItems,
        searchQuery,
        itemsMap,
        updateOpenItems,
        updateSearchQuery,
      }) => (
        <SelectionTree
          i18n={i18n}
          {...restProps}
          items={items}
          defaultCheckedItems={defaultCheckedItems}
          checkedItems={checkedItems}
          searchQuery={searchQuery}
          itemsMap={itemsMap}
          openItems={openItems}
          onChange={onChange}
          updateOpenItems={updateOpenItems}
          updateSearchQuery={updateSearchQuery}
        />
      )}
    </SelectionTreeContext.Consumer>
  </SelectionTreeProvider>
);

export const ContextualHybridSelectionTree: React.FC<IContextualSelectionTreeProps> = ({
  treeItems,
  checkedItems,
  defaultCheckedItems,
  customFilter,
  fetchData,
  onChange,
  i18n,
  ...restProps
}) => (
  <SelectionTreeProvider>
    <HybridClientDataSource
      treeItems={treeItems}
      fetchData={fetchData}
      customFilter={customFilter}
    />
    <SelectionTreeContext.Consumer>
      {({
        items,
        openItems,
        searchQuery,
        itemsMap,
        updateOpenItems,
        updateSearchQuery,
      }) => (
        <SelectionTree
          {...restProps}
          i18n={i18n}
          items={items}
          defaultCheckedItems={defaultCheckedItems}
          checkedItems={checkedItems}
          searchQuery={searchQuery}
          itemsMap={itemsMap}
          openItems={openItems}
          onChange={onChange}
          updateOpenItems={updateOpenItems}
          updateSearchQuery={updateSearchQuery}
        />
      )}
    </SelectionTreeContext.Consumer>
  </SelectionTreeProvider>
);

export const ContextualServerSelectionTree: React.FC<IContextualSelectionTreeProps> = ({
  checkedItems,
  defaultCheckedItems,
  customFilter,
  fetchData,
  onChange,
  i18n,
  ...restProps
}) => (
  <SelectionTreeProvider>
    <ServerDataSource
      fetchData={fetchData}
      customFilter={customFilter}
    />
    <SelectionTreeContext.Consumer>
      {({
        items,
        openItems,
        searchQuery,
        itemsMap,
        updateOpenItems,
        updateSearchQuery,
        isLoading,
      }) => (
        <SelectionTree
          {...restProps}
          isLoading={isLoading}
          i18n={i18n}
          items={items}
          defaultCheckedItems={defaultCheckedItems}
          checkedItems={checkedItems}
          searchQuery={searchQuery}
          itemsMap={itemsMap}
          openItems={openItems}
          onChange={onChange}
          updateOpenItems={updateOpenItems}
          updateSearchQuery={updateSearchQuery}
        />
      )}
    </SelectionTreeContext.Consumer>
  </SelectionTreeProvider>
);
